import { render, staticRenderFns } from "./DoubleClickConfirmButton.vue?vue&type=template&id=14530fba&scoped=true&"
import script from "./DoubleClickConfirmButton.vue?vue&type=script&lang=js&"
export * from "./DoubleClickConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./DoubleClickConfirmButton.vue?vue&type=style&index=0&id=14530fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14530fba",
  null
  
)

export default component.exports